<div class="delete-discount-options-modal">
    <h2 class="title">Remove Discount Rule</h2>
    <p class="text-body-s" style="margin-bottom: var(--spacing-m)">
        How should existing subscriptions with this discount be handled?
    </p>
    <div class="options">
        <button
            type="button"
            class="j-button j-button--type-2 option-button"
            (click)="selectOption('continue')"
        >
            <span class="text-button">Continue to honour the benefit of the logic to current subscriptions. Post the completion of N cycles of the subscription, the subscriptions will be shifted to the original plan price.</span>
        </button>
        <button
            type="button"
            class="j-button j-button--type-2 option-button"
            (click)="selectOption('discontinue')"
        >
            <span class="text-button">Do not continue to honour the benefit of the logic to current subscriptions. The subscriptions will be shifted to the original plan price post completion of the current cycle.</span>
        </button>
    </div>
</div>

<div class="modal-actions">
    <button type="button" class="j-button j-button--type-1" (click)="cancel()">
        <span class="text-button">Cancel</span>
    </button>
</div>
